import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { getEnumValues } from "../../../../react-core/Utils/Enum";
import { Alert } from "../../Components/Alert";
import { AlertType } from "../../Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";
import { reuseTooltip, reuseType, targetAllocationAlert } from "../Resource/Content";

interface IReuseInvesmentProps extends IProcessComponentProps {
    onReuseInvesment: (v) => void;
}

interface IReuseInvesmentState {
    type: reuseType;
}

export class ReuseInvesment extends ProcessComponent<IReuseInvesmentProps, IReuseInvesmentState> {
    constructor(props: IReuseInvesmentProps) {
        super(props);
        this.state = {
            type: reuseType.no,
        };
    }

    render() {
        return (
            <>
                <RadiosEditor
                    cssWrapper="control-size-430 mb-30 rg-inline"
                    selected={this.state.type}
                    label={"Do you want to reuse investments?"}
                    tooltip={reuseTooltip}
                    options={getEnumValues(reuseType)}
                    onChange={(v) => {
                        this.setState({ type: v }, () => {
                            this.props.onReuseInvesment(this.state.type);
                        });
                    }}
                    getText={(o) => o}
                />
                {this.state.type == reuseType.useTargetAllocation && (
                    <Alert alertType={AlertType.Warning} message={targetAllocationAlert} />
                )}
            </>
        );
    }
}
